import { WSText } from "@wingspanhq/fe-component-library";
import {
  ICheckbookCard,
  PayoutDestinationType
} from "@wingspanhq/payments/dist/interfaces";
import { AxiosError } from "axios";
import React from "react";
import { AddDebitCardForm } from "../../../components/AddDebitCardForm/AddDebitCardForm";
import { OverlaySpinner } from "../../../components/OverlaySpinner";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { SetupLayout } from "../../../components/SetupFlow/SetupFlowLayout";
import { useWSMutation } from "../../../query/helpers";
import { useUserId } from "../../../query/hooks/helpers";
import { QUERY_PAYOUT_SETTINGS } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";

export const SetupPayoutsInstantRTP: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();

  const [submit, submitMeta] = useWSMutation<
    any,
    AxiosError,
    { debitCard: ICheckbookCard }
  >(
    async ({ debitCard }) => {
      return await paymentsService.payoutSettings.update(userId, {
        instant: {
          destinationId: debitCard.cardId,
          destinationType: PayoutDestinationType.Card
        }
      });
    },
    {
      dependencies: [QUERY_PAYOUT_SETTINGS],
      onSuccess: onNext
    }
  );

  return (
    <SetupLayout
      title="Connect your debit card for instant payouts"
      onBack={onBack}
    >
      <WSText mb="M">
        Instantly receive funds to a supported debit card as soon as the funds
        are received. Income typically appear in the associated bank account
        within 30 minutes.
      </WSText>
      <WSText mb="M">
        Instant payouts cost 1% of the payout amount, with a minimum fee of
        $0.50.
      </WSText>
      <WSText>
        Most U.S. banks issue debit cards are compatible with Instant Payouts.
      </WSText>

      <AddDebitCardForm
        mt="L"
        onSubmit={debitCard => {
          submit({ debitCard });
        }}
      />

      {submitMeta.isLoading && <OverlaySpinner />}
    </SetupLayout>
  );
};
